/*
* BREEZE – eigenes JavaScript
*
* Wird in layout/theme.liquid eingebunden (Script-Tag am Ende des <body>).
* Die Beispiel-Listener von Pipeline wurden entfernt – sie haben bei jedem
* Scroll-Event in die Konsole geloggt und waren nur als Demo gedacht.
*/

(function () {

  var CART_DRAWER = '[data-drawer="drawer-cart"]';
  var closeHandlerAttached = false;
  var lastAddedQuantity = 1;

  /* Tatsächlich hinzugefügte Menge merken.

     Wichtig: Die Antwort von /cart/add.js enthält als "quantity" die
     GESAMTmenge dieser Variante im Warenkorb – nicht die gerade
     hinzugefügte. Legt man zweimal 1 Stück desselben Artikels rein,
     meldet Shopify beim zweiten Mal 2. Deshalb lesen wir die Menge
     beim Klick direkt aus dem Formular aus.

     Capture-Phase, damit wir vor dem Theme-Handler dran sind. */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-add-to-cart]');
    if (!button) {
      return;
    }

    var form = button.closest('form');
    var input = form ? form.querySelector('[name="quantity"]') : null;
    var value = input ? parseInt(input.value, 10) : 1;

    lastAddedQuantity = value > 0 ? value : 1;
  }, true);

  /* Bestätigung im Drawer ein-/ausblenden */
  function showAddedMessage(drawer) {
    var box = drawer.querySelector('[data-cart-added]');
    if (!box) {
      return;
    }

    var label = box.querySelector('[data-cart-added-text]');

    if (label) {
      label.textContent = lastAddedQuantity === 1
        ? '1 Artikel wurde hinzugefügt'
        : lastAddedQuantity + ' Artikel wurden hinzugefügt';
    }

    box.hidden = false;

    // Beim Schließen des Drawers wieder zurücksetzen
    if (!closeHandlerAttached) {
      drawer.addEventListener('theme:drawer:close', function () {
        box.hidden = true;
      });
      closeHandlerAttached = true;
    }
  }

  /* Drawer erst öffnen, wenn das Theme den neuen Warenkorb-Stand kennt.

     Hintergrund: theme.js holt nach dem Hinzufügen den Warenkorb per
     updateHeaderTotal() asynchron nach und meldet ihn über das Event
     theme:cart:change. Öffnet man den Drawer vorher, arbeitet er noch
     mit dem alten Stand – beim allerersten Artikel also mit einem
     leeren Warenkorb und zeigt "Einkaufswagen ist leer". */
  function openWhenCartReady(drawer) {
    var opened = false;

    function open() {
      if (opened) {
        return;
      }
      opened = true;
      document.removeEventListener('theme:cart:change', open);
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
        bubbles: false
      }));
    }

    document.addEventListener('theme:cart:change', open);

    // Sicherheitsnetz, falls das Event ausbleibt (z.B. Netzwerkfehler)
    setTimeout(open, 1500);
  }

  /* ------------------------------------------------------------
     Nach "In den Einkaufswagen": Warenkorb-Drawer statt Popdown

     Breeze öffnet nach dem Hinzufügen fest verdrahtet das schmale
     Popdown von oben (siehe handleSuccess() in theme.js) – dafür
     gibt es keine Theme-Einstellung. Wir fangen das Popdown-Event
     in der Capture-Phase ab (läuft dadurch vor dem Theme-Listener)
     und öffnen stattdessen den Cart-Drawer.

     Der Drawer lädt seinen Inhalt beim Öffnen selbst neu, das neu
     hinzugefügte Produkt ist also sofort sichtbar – inklusive
     Checkout-Button.
     ------------------------------------------------------------ */

  document.addEventListener('theme:cart:popdown', function (event) {
    var cartDrawer = document.querySelector(CART_DRAWER);

    // Kein Drawer vorhanden (z.B. Cart-Style auf "Page")? Theme-Standard lassen.
    if (!cartDrawer) {
      return;
    }

    // Popdown unterdrücken
    event.stopImmediatePropagation();

    // Bestätigung vorbereiten
    showAddedMessage(cartDrawer);

    // Drawer öffnen, sobald der Warenkorb-Stand aktuell ist
    openWhenCartReady(cartDrawer);
  }, true); // true = Capture-Phase, wichtig!

  /* ------------------------------------------------------------
     Gewährleistungshinweis: Panel auf-/zuklappen

     Event-Delegation auf document, damit der Toggle auch nach einem
     Re-Render des Warenkorb-Drawers weiter funktioniert.
     ------------------------------------------------------------ */

  function setWarrantyOpen(notice, open) {
    var toggle = notice.querySelector('[data-warranty-toggle]');
    var panel = notice.querySelector('[data-warranty-panel]');
    if (!toggle || !panel) {
      return;
    }

    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  }

  document.addEventListener('click', function (event) {
    // Klick auf die Hinweiszeile: auf-/zuklappen
    var toggle = event.target.closest('[data-warranty-toggle]');
    if (toggle) {
      var notice = toggle.closest('[data-warranty-notice]');
      if (notice) {
        setWarrantyOpen(notice, toggle.getAttribute('aria-expanded') !== 'true');
      }
      return;
    }

    // Klick auf das aufgeklappte Label: schliesst es wieder.
    // Links darin bleiben ausgenommen, sonst waere europa.eu nicht klickbar.
    var panel = event.target.closest('[data-warranty-panel]');
    if (panel && !event.target.closest('a')) {
      var openNotice = panel.closest('[data-warranty-notice]');
      if (openNotice) {
        setWarrantyOpen(openNotice, false);
      }
    }
  });

  /* Esc schließt ein geöffnetes Panel */
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    var open = document.querySelectorAll('[data-warranty-toggle][aria-expanded="true"]');
    if (!open.length) {
      return;
    }

    // Verhindert, dass Esc gleichzeitig den Drawer schliesst
    event.stopPropagation();

    Array.prototype.forEach.call(open, function (toggle) {
      var notice = toggle.closest('[data-warranty-notice]');
      if (notice) {
        setWarrantyOpen(notice, false);
      }
      toggle.focus();
    });
  }, true);

  /* ------------------------------------------------------------
     "Warum dieses Produkt": nur die ersten Punkte zeigen,
     der Rest per Button aufklappbar.
     ------------------------------------------------------------ */

  var BULLETS_VISIBLE = 3;

  function initBulletToggle(list) {
    if (list.dataset.bulletToggle) {
      return;
    }

    var items = list.children;
    var hiddenCount = items.length - BULLETS_VISIBLE;
    if (hiddenCount < 1) {
      return;
    }

    list.dataset.bulletToggle = 'true';

    var i;
    for (i = BULLETS_VISIBLE; i < items.length; i++) {
      items[i].classList.add('bullet-hidden');
    }

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bullet-more';
    button.setAttribute('aria-expanded', 'false');

    var labelMore = hiddenCount === 1
      ? 'Einen weiteren Punkt anzeigen'
      : hiddenCount + ' weitere Punkte anzeigen';

    button.innerHTML = '<span class="bullet-more__label">' + labelMore + '</span>'
      + '<svg class="bullet-more__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" '
      + 'fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" '
      + 'stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"></polyline></svg>';

    button.addEventListener('click', function () {
      var isOpen = button.getAttribute('aria-expanded') === 'true';
      var n;

      for (n = BULLETS_VISIBLE; n < items.length; n++) {
        items[n].classList.toggle('bullet-hidden', isOpen);
      }

      button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      button.querySelector('.bullet-more__label').textContent = isOpen
        ? labelMore
        : 'Weniger anzeigen';
    });

    list.insertAdjacentElement('afterend', button);
  }

  function initAllBulletToggles() {
    var lists = document.querySelectorAll('.product__block__text ul');
    Array.prototype.forEach.call(lists, initBulletToggle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllBulletToggles);
  } else {
    initAllBulletToggles();
  }

  // Theme-Editor: Section neu geladen
  document.addEventListener('shopify:section:load', initAllBulletToggles);

  /* ------------------------------------------------------------
     Shopify Forms: Rogan auch im Shadow DOM durchsetzen.

     Die App haengt ein eigenes Element in [data-form-root] ein und
     rendert das Formular in einen (ggf. verschachtelten oder
     geschlossenen) Shadow Root – dort greift custom.css nicht.

     1. attachShadow wird abgefangen: so bekommen wir auch
        geschlossene Shadow Roots zu fassen.
     2. Regelmaessiger Scan: findet offene Shadow Roots und prueft,
        ob sie zum Formular gehoeren – nur dort wird Rogan gesetzt,
        andere Shadow Roots (z.B. Shop Pay) bleiben unangetastet.
     ------------------------------------------------------------ */

  var FORMS_FONT_CSS = '*, *::before, *::after, input, textarea, select, button, label {'
    + ' font-family: "Rogan", sans-serif !important; }';
  var knownShadows = [];

  function isInForm(el) {
    while (el) {
      if (el.closest && el.closest('[data-form-root]')) {
        return true;
      }
      var root = el.getRootNode ? el.getRootNode() : null;
      el = root && root.host ? root.host : null;
    }
    return false;
  }

  function injectFont(shadow) {
    if (!shadow || shadow.querySelector('style[data-breeze-font]')) {
      return;
    }
    var style = document.createElement('style');
    style.setAttribute('data-breeze-font', '');
    style.textContent = FORMS_FONT_CSS;
    shadow.appendChild(style);
  }

  // 1. Auch geschlossene Shadow Roots mitschneiden
  if (Element.prototype.attachShadow && !Element.prototype.attachShadow.__breeze) {
    var originalAttach = Element.prototype.attachShadow;
    var patched = function () {
      var shadow = originalAttach.apply(this, arguments);
      knownShadows.push({ host: this, shadow: shadow });
      return shadow;
    };
    patched.__breeze = true;
    Element.prototype.attachShadow = patched;
  }

  function scanShadows(node) {
    var els = node.querySelectorAll('*');
    Array.prototype.forEach.call(els, function (el) {
      if (el.shadowRoot) {
        injectFont(el.shadowRoot);
        scanShadows(el.shadowRoot);
      }
    });
  }

  function styleForms() {
    // Offene Shadow Roots innerhalb der Formulare
    Array.prototype.forEach.call(document.querySelectorAll('[data-form-root]'), scanShadows);

    // Abgefangene (auch geschlossene) Shadow Roots, sofern sie zum Formular gehoeren
    knownShadows.forEach(function (entry) {
      if (entry.host.isConnected && isInForm(entry.host)) {
        injectFont(entry.shadow);
        scanShadows(entry.shadow);
      }
    });
  }

  function initFormsFont() {
    if (!document.querySelector('[data-form-root]')) {
      return;
    }
    var runs = 0;
    var timer = setInterval(function () {
      styleForms();
      runs++;
      // 60 Sekunden lang alle 500 ms – deckt auch spaet geladene Formulare ab
      if (runs > 120) {
        clearInterval(timer);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormsFont);
  } else {
    initFormsFont();
  }

})();

/* ------------------------------------------------------------
   Gratis Sauna Brew "Birke" ab 85 € (v5)

   Ab 85 € Warenkorbwert (ohne das Geschenk) liegt das Birke-Brew
   als EIGENE Position im Warenkorb (Eigenschaft "Gratis-Zugabe"),
   getrennt von einem selbst gekauften Birke-Brew. Den Preis auf
   0 € setzt der automatische Rabatt "Gratis Brew" im Admin.

   Prinzip: Das Script ändert den Warenkorb NIE hinter dem Rücken
   des Themes. Es hängt sich in die Warenkorb-Requests des Themes
   ein und gleicht das Geschenk ab, BEVOR das Theme die Antwort
   bekommt:
   - /cart/add.js: Geschenk abgleichen, dann gibt das Theme seine
     Antwort weiter und lädt danach den (schon fertigen) Warenkorb.
   - /cart/change.js, /cart/update.js: Geschenk abgleichen und dem
     Theme den FINALEN Warenkorb als Antwort geben. Der Drawer
     rendert so immer den echten Stand – mit gültigen Zeilen-
     nummern und Keys.
   - Seitenaufruf: still abgleichen (auf /cart danach 1x neu laden).

   Entfernt der Kunde das Geschenk selbst, kommt es in dieser
   Sitzung nicht wieder (bis der Wert unter 85 € fällt).

   Schutz: max. 6 Änderungen pro Minute, bei Fehlern 10 Minuten
   Pause pro Sitzung, auf /cart max. 2 Reloads pro Minute,
   max. 3 s Wartezeit – das Theme bleibt nie hängen.
   ------------------------------------------------------------ */
(function () {
  const GIFT_VARIANT_ID = 55221047067010;          // BREEZE Sauna Brew "Birke" 40 g
  const THRESHOLD = 8500;                          // 85,00 € in Cent
  const DISCOUNT_TITLE = 'Gratis Brew';            // exakt wie der Rabatt-Titel im Admin
  const GIFT_PROP = 'Gratis-Zugabe';
  const GIFT_PROP_VALUE = 'ab 85 € Einkaufswert';
  const MAX_ACTIONS_PER_MIN = 6;
  const MAX_WAIT = 3000;
  const DEBUG = true;                              // nach dem Test auf false

  const LOCK_KEY = 'breezeGiftLock';
  const DECLINED_KEY = 'breezeGiftDeclined';
  const RELOADS_KEY = 'breezeGiftReloads';
  const CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const CART_JSON_WRITE = /\/cart\/(change|update|clear)\.js/;

  const nativeFetch = window.fetch.bind(window);
  const log = (...a) => { if (DEBUG) console.log('[Gratis-Brew]', ...a); };

  let queue = Promise.resolve();
  let giftKey = null;
  let giftLine = null;
  let actionTimes = [];

  /* ---------- Hilfsfunktionen ---------- */

  const ss = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del(k) { try { sessionStorage.removeItem(k); } catch (e) {} }
  };

  const onCartPage = () => /\/cart\/?$/.test(location.pathname);
  const locked = () => Date.now() - Number(ss.get(LOCK_KEY) || 0) < 600000;
  function lock(reason) {
    ss.set(LOCK_KEY, String(Date.now()));
    console.warn('[Gratis-Brew] gestoppt (10 Min.):', reason);
  }

  function rateOk() {
    const now = Date.now();
    actionTimes = actionTimes.filter(t => now - t < 60000);
    if (actionTimes.length >= MAX_ACTIONS_PER_MIN) return false;
    actionTimes.push(now);
    return true;
  }

  async function api(url, body) {
    const r = await nativeFetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: body ? JSON.stringify(body) : undefined
    });
    const data = await r.json().catch(() => ({}));
    return { ok: r.ok, status: r.status, data };
  }

  const timeout = ms => new Promise(resolve => setTimeout(() => resolve(false), ms));

  function isGift(item) {
    if (Number(item.variant_id) !== GIFT_VARIANT_ID) return false;
    const p = item.properties || {};
    return !!(p[GIFT_PROP] || p._gift);
  }

  // Originalpreis minus alle Rabatte außer "Gratis Brew" – die Schwelle kippt nicht
  function lineValue(item) {
    const other = (item.line_level_discount_allocations || [])
      .filter(a => !(a.discount_application && a.discount_application.title === DISCOUNT_TITLE))
      .reduce((s, a) => s + Number(a.amount || 0), 0);
    return Number(item.original_line_price || 0) - other;
  }

  function parseBody(body) {
    try {
      if (!body) return null;
      if (typeof body === 'string') {
        try { return JSON.parse(body); } catch (e) { return Object.fromEntries(new URLSearchParams(body)); }
      }
      if (body instanceof FormData || body instanceof URLSearchParams) return Object.fromEntries(body);
    } catch (e) {}
    return null;
  }

  function detectDecline(body) {
    if (!giftKey) return;
    const p = parseBody(body);
    if (!p) return;
    const zero = v => v !== undefined && v !== null && String(v) === '0';
    const byKey = p.id === giftKey && zero(p.quantity);
    const byLine = giftLine && Number(p.line) === giftLine && zero(p.quantity);
    const byUpdates = (p.updates && typeof p.updates === 'object' && !Array.isArray(p.updates) && zero(p.updates[giftKey]))
      || zero(p['updates[' + giftKey + ']']);
    if (byKey || byLine || byUpdates) {
      ss.set(DECLINED_KEY, '1');
      log('Kunde hat das Geschenk entfernt – kommt in dieser Sitzung nicht wieder');
    }
  }

  function reloadCartPage() {
    let r = [];
    try { r = JSON.parse(ss.get(RELOADS_KEY) || '[]').filter(t => Date.now() - t < 60000); } catch (e) {}
    if (r.length >= 2) { lock('Reload-Schleife verhindert'); return; }
    r.push(Date.now());
    ss.set(RELOADS_KEY, JSON.stringify(r));
    location.reload();
  }

  /* ---------- Kernlogik: gibt true zurück, wenn der Warenkorb geändert wurde ---------- */

  async function doSync() {
    if (locked()) { log('pausiert nach Fehler'); return false; }

    const res = await api('/cart.js');
    if (!res.ok) { lock('Warenkorb nicht lesbar (' + res.status + ')'); return false; }
    const items = res.data.items || [];

    const giftItems = items.filter(isGift);
    const subtotal = items.filter(i => !isGift(i)).reduce((s, i) => s + lineValue(i), 0);
    if (subtotal < THRESHOLD) ss.del(DECLINED_KEY);
    const wantGift = subtotal >= THRESHOLD && ss.get(DECLINED_KEY) !== '1';

    const updates = {};
    giftItems.forEach((g, idx) => {
      const target = wantGift && idx === 0 ? 1 : 0;
      if (g.quantity !== target) updates[g.key] = target;
    });
    const needAdd = wantGift && giftItems.length === 0;

    log('Wert ohne Geschenk:', (subtotal / 100).toFixed(2), '€ | Geschenk-Positionen:', giftItems.length);

    if (needAdd || Object.keys(updates).length) {
      if (!rateOk()) { lock('zu viele Änderungen pro Minute'); return false; }
      const out = needAdd
        ? await api('/cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { [GIFT_PROP]: GIFT_PROP_VALUE } }] })
        : await api('/cart/update.js', { updates });
      if (!out.ok) { lock(out.data.description || out.data.message || ('HTTP ' + out.status)); return false; }
      log(needAdd ? 'Geschenk hinzugefügt' : 'Geschenk angepasst/entfernt');
    }

    // Aktuellen Stand für die Ablehnungs-Erkennung merken
    const fresh = (needAdd || Object.keys(updates).length) ? (await api('/cart.js')).data.items || [] : items;
    const g = fresh.find(isGift);
    giftKey = g ? g.key : null;
    giftLine = g ? fresh.indexOf(g) + 1 : null;

    return !!(needAdd || Object.keys(updates).length);
  }

  // Strikt nacheinander – nie zwei Abgleiche gleichzeitig
  function sync() {
    const run = queue.then(doSync).catch(e => { lock(e && e.message); return false; });
    queue = run.then(() => {}, () => {});
    return Promise.race([run, timeout(MAX_WAIT)]);
  }

  /* ---------- In die Warenkorb-Requests des Themes einhängen ---------- */

  window.fetch = async function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!CART_WRITE.test(url)) return nativeFetch(input, init);

    const body = init && init.body;
    const isAdd = /\/cart\/add/.test(url);
    if (!isAdd) detectDecline(body);

    const response = await nativeFetch(input, init);
    if (!response.ok) return response;          // Theme-Fehler unverändert durchreichen

    const changed = await sync();
    if (!changed || isAdd || !CART_JSON_WRITE.test(url)) return response;

    // change/update/clear: dem Theme den finalen Warenkorb zurückgeben
    try {
      const cart = await api('/cart.js');
      if (!cart.ok) return response;
      return new Response(JSON.stringify(cart.data), {
        status: 200,
        headers: { 'Content-Type': 'application/json' }
      });
    } catch (e) {
      return response;
    }
  };

  // Fallback, falls Teile des Themes XMLHttpRequest nutzen
  const xhrOpen = XMLHttpRequest.prototype.open;
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__breezeUrl = String(url);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    const url = this.__breezeUrl || '';
    if (CART_WRITE.test(url)) {
      if (!/\/cart\/add/.test(url)) detectDecline(body);
      this.addEventListener('load', () => {
        if (this.status < 200 || this.status >= 300) return;
        log('Hinweis: Warenkorb-Änderung per XHR', url);
        sync().then(changed => { if (changed && onCartPage()) reloadCartPage(); });
      });
    }
    return xhrSend.apply(this, arguments);
  };

  /* ---------- Start ---------- */

  function initialSync() {
    sync().then(changed => { if (changed && onCartPage()) reloadCartPage(); });
  }

  window.addEventListener('pageshow', e => { if (e.persisted) initialSync(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialSync);
  else initialSync();

  log('Script geladen');
})();